/*
 * Dragon Vault theme.js
 * Two jobs, both progressive enhancements:
 *  1. Keep the displayed price and add-to-cart button in sync with the
 *     selected variant.
 *  2. Tilt the hero slab toward the pointer (fine pointers only, skipped
 *     entirely when the visitor prefers reduced motion).
 * Everything else in the theme posts natively, so the storefront keeps
 * working with JavaScript disabled. Scroll entrance motion is pure CSS
 * (animation-timeline) and needs no code here.
 */
(function () {
  'use strict';

  function initVariantSelect(select) {
    var scope = select.closest('[data-product]') || document;
    var priceEl = scope.querySelector('[data-price-display]');
    var button = scope.querySelector('[data-add-button]');

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (!option) return;

      if (priceEl && option.dataset.price) {
        priceEl.textContent = option.dataset.price;
      }

      if (button) {
        var available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available
          ? (button.dataset.addText || 'Add to vault')
          : (button.dataset.soldOutText || 'Sold out');
      }
    });
  }

  function initSlabTilt() {
    var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
    var finePointer = window.matchMedia('(pointer: fine)').matches;
    if (!motionOk || !finePointer) return;

    var wraps = document.querySelectorAll('.slab-wrap');
    for (var i = 0; i < wraps.length; i++) {
      (function (wrap) {
        var slab = wrap.querySelector('.slab');
        if (!slab) return;

        wrap.addEventListener('pointermove', function (event) {
          var rect = wrap.getBoundingClientRect();
          var x = (event.clientX - rect.left) / rect.width - 0.5;
          var y = (event.clientY - rect.top) / rect.height - 0.5;
          slab.style.transform =
            'rotate(-2deg) rotateX(' + (-y * 10).toFixed(2) + 'deg) rotateY(' + (x * 10).toFixed(2) + 'deg)';
        });

        wrap.addEventListener('pointerleave', function () {
          slab.style.transform = '';
        });
      })(wraps[i]);
    }
  }

  function init() {
    var selects = document.querySelectorAll('[data-variant-select]');
    for (var i = 0; i < selects.length; i++) {
      initVariantSelect(selects[i]);
    }
    initSlabTilt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
